export enum MediaType {
  MOBILE_S = 0,
  MOBILE = 1,
  TABLET = 2,
  DESKTOP = 3,
  DESKTOP_L = 4,
}

export enum MediaQuery {
  DESKTOP_L = '(min-width: 1475px)',
  DESKTOP = '(min-width: 1168px) and (max-width: 1475px)',
  TABLET = '(min-width: 1016px) and (max-width: 1168px)',
  MOBILE = '(min-width: 658px) and (max-width: 1016px)',
  MOBILE_S = '(max-width: 658px)',
}

export enum GameType {
  DESKTOP = 'allowed_desktop',
  MOBILE = 'allowed_mobile',
}
